import React from 'react'
import { css } from '@emotion/core'
import {
  HeaderBlock,
  Body1,
  Button,
  Divider,
  Separator,
  useContainerWidth,
  BillboardButton,
  LayoutBand,
  Row,
} from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { i18n } from '@fs/zion-locale'
import { useLocation } from '@fs/zion-router'
import portraitImage from './assets/landing-portrait.jpg'
import recordImage from './assets/landing-record.png'
import { getExternalBaseUrl } from '../../services/url-service'
import useDefaultScripts from '../../services/default-scripts-service'

const homePageBodyCss = css`
  padding-top: 32px;
  padding-bottom: 32px;
`

const surnameContainerCss = css`
  text-align: center;
  width: 100%;
`

const imageCss = css`
  height: 256px;
  width: 256px;
`

export default function HomePageBody(): JSX.Element {
  const atWidth = useContainerWidth()
  const isMobile = atWidth({ default: true, lg: false })
  const [t] = useTranslation()
  const location = useLocation()
  const scripts = useDefaultScripts() || {}
  const doExternalLink = location.pathname.endsWith(`/${i18n.language}`) || window?.location?.hostname === 'localhost'

  return (
    <LayoutBand maxWidth="sm" css={homePageBodyCss}>
      <div css={surnameContainerCss}>
        <HeaderBlock size="sm" heading={t('ancestors.surname-directory.header')} />
        <Body1>{t('ancestors.surname-directory.description')}</Body1>
        <Separator size="xxs" />
        <BillboardButton
          data-testid="browse-surnames"
          // eslint-disable-next-line sonarjs/no-nested-template-literals -- simpler this way
          to={`${doExternalLink ? `/${i18n.language}` : ''}/surnames/${scripts[i18n.language] || 'latn'}`}
          linkName="Browse Surname Directory"
          external={doExternalLink}
        >
          {t('ancestors.surname-directory.action')}
        </BillboardButton>
      </div>

      <Separator size="md" />
      <Divider />
      <Separator size="md" />

      <Row wrap={isMobile} gutters="md" alignY="middle" alignX="center">
        {/* @ts-expect-error: TypeScript doesn't think we should be putting noShrinkX on this element, but it is fine. */}
        <img noShrinkX src={portraitImage} css={imageCss} alt={t('ancestors.portrait.alt')} />

        <div>
          <HeaderBlock size="sm" heading={t('ancestors.memories-section.header')} />
          <Body1>{t('ancestors.memories-section.description')}</Body1>
          <Button to={`${getExternalBaseUrl()}/memories`} linkName="Get Started" data-testid="get-started">
            {t('ancestors.portrait.link')}
          </Button>
        </div>
      </Row>

      <Separator size="md" />

      <Row wrap={isMobile} gutters="md" alignY="middle" alignX="center">
        {/* @ts-expect-error: TypeScript doesn't think we should be putting noShrinkX on this element, but it is fine. */}
        {isMobile && <img noShrinkX src={recordImage} css={imageCss} alt={t('ancestors.record.alt')} />}

        <div>
          <HeaderBlock size="sm" heading={t('ancestors.historical-records.header')} />
          <Body1>{t('ancestors.historical-records.description')}</Body1>
          <Button to={`${getExternalBaseUrl()}/search`} linkName="View Records Now" data-testid="view-records-now">
            {t('ancestors.historical-records.action')}
          </Button>
        </div>
        {/* @ts-expect-error: TypeScript doesn't think we should be putting noShrinkX on this element, but it is fine. */}
        {!isMobile && <img noShrinkX src={recordImage} css={imageCss} alt={t('ancestors.record.alt')} />}
      </Row>
    </LayoutBand>
  )
}
